import React from "react";

import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {CxAppColor} from "./CxColor";
import {CxSection, CxSmallText, CxInfo} from "./CxTypography"
import {Capa} from "../domain/Capa";


// ------------------------------------------------------------------------------------------------------------------
// worker capa
// ------------------------------------------------------------------------------------------------------------------

export function CxCapa({ showNumbers, dataSets }) {
    const colors = CxAppColor.capa;
    const emptyColors = CxAppColor.emptyCapa;

    return (
        <Box sx={{ padding: 0, overflowY: "auto" }}>
            {Object.entries(dataSets).map(([key, loadData]) => (  // Use .entries() for Map
                <Accordion key={key} defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>{ Capa.getLoadLabel(key) }</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        {[...loadData.entries()].map(([group, loads]) => (  // Use .entries() for inner Map
                            <Box key={group} sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
                                <Typography variant="body2" sx={{ fontWeight: "normal", width: 100 }}>
                                    {group}
                                </Typography>
                                <Box sx={{ display: "flex", gap: 0.5, alignItems: "flex-end" }}>
                                    {loads.map((count, index) => (
                                        showNumbers ? (
                                            <Typography key={index} sx={{ width: 12, textAlign: "center" }}>
                                                {count > 0 ? count : "-"}
                                            </Typography>
                                        ) : (
                                            <Box
                                                key={index}
                                                sx={{
                                                    width: 12,
                                                    height: count > 0 ? `${(count / 4) * 50}px` : "2px",
                                                    backgroundColor: count > 0 ? colors[index] : emptyColors[index],
                                                    borderRadius: 0,
                                                }}
                                            />
                                        )
                                    ))}
                                </Box>
                            </Box>
                        ))}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};


// ------------------------------------------------------------------------------------------------------------------
// tool capa
// ------------------------------------------------------------------------------------------------------------------

export function CxToolCapa({ dataSets }) {
    const colors = CxAppColor.capa;
    const emptyColors = CxAppColor.emptyCapa;
    const dayLabels = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

    // Find the maximum bar height for alignment
    const maxLoad = Math.max(...dataSets.flatMap(({ loads }) => loads));

    return (
        <Box sx={{ padding: 0, overflowX: "auto", display: "flex", gap: 6, alignItems: "flex-end" }}>  {/* 🔹 Increased gap to 6 */}
            {dataSets.map(({ key, loads, code }) => (
                <Box key={key} sx={{ minWidth: 140, textAlign: "center", paddingX: 2 }}>  {/* 🔹 Added paddingX: 2 */}

                    <CxSection>{code.value}</CxSection>
                    <CxInfo sx={{mb: 2}}>(Total {code.quantity} Stk.)</CxInfo>

                    <Box sx={{ display: "flex", gap: 0.5, alignItems: "flex-end", minHeight: `${(maxLoad / 4) * 25}px` }}>  {/* 🔹 Increased gap between bars */}
                        {loads.map((count, index) => (
                            <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Box
                                    sx={{
                                        width: 24,
                                        height: count > 0 ? `${(count / 4) * 25}px` : "2px",
                                        backgroundColor: count > 0 ? colors[index] : emptyColors[index],
                                        borderRadius: 0,
                                    }}
                                />

                                <CxSmallText>{dayLabels[index]}</CxSmallText>
                                <CxSmallText>{count}</CxSmallText>

                                <CxSmallText sx={{mt: 1, mb: 2, color: (code.quantity - count) < 0 ? "red" : "green"}}>
                                    {code.quantity - count}
                                </CxSmallText>
                            </Box>
                        ))}
                    </Box>

                </Box>
            ))}
        </Box>
    );
}
